import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ROUTES } from '@shared/config';
import { usePageviewTracking } from '@shared/lib';
import { RequireAuth } from './RequireAuth';
import { RequireGuest } from './RequireGuest';
import { LegacyImportRedirect } from './LegacyImportRedirect';
import { NoticeProvider } from './NoticeProvider';
import styles from './providers.module.css';

const LoginPage = lazy(() =>
  import('@pages/LoginPage').then((m) => ({ default: m.LoginPage }))
);

const BloggersPage = lazy(() =>
  import('@pages/BloggersPage').then((m) => ({ default: m.BloggersPage }))
);

const EstimatesPage = lazy(() =>
  import('@pages/EstimatesPage').then((m) => ({ default: m.EstimatesPage }))
);

const EstimateNewPage = lazy(() =>
  import('@pages/EstimateNewPage').then((m) => ({ default: m.EstimateNewPage }))
);

const EstimatePage = lazy(() =>
  import('@pages/EstimatePage').then((m) => ({ default: m.EstimatePage }))
);

const NotFoundPage = lazy(() =>
  import('@pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage }))
);

function PageLoader() {
  return (
    <div className={styles.pageLoader}>
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 48, color: 'var(--color-brand-lime)' }} spin />}
      />
    </div>
  );
}

// usePageviewTracking использует useLocation, поэтому должен жить
// внутри <BrowserRouter>.
function RoutesWithAnalytics() {
  usePageviewTracking();
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path={ROUTES.HOME} element={<Navigate to={ROUTES.BLOGGERS} replace />} />

        <Route element={<RequireGuest />}>
          <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        </Route>

        <Route element={<RequireAuth />}>
          <Route path={ROUTES.BLOGGERS} element={<BloggersPage />} />
          <Route path={ROUTES.ESTIMATES} element={<EstimatesPage />} />
          <Route path={ROUTES.ESTIMATE_NEW} element={<EstimateNewPage />} />
          <Route path={ROUTES.ESTIMATE_IMPORT} element={<LegacyImportRedirect />} />
          <Route path={ROUTES.ESTIMATE} element={<EstimatePage />} />
        </Route>

        <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND} replace />} />
      </Routes>
    </Suspense>
  );
}

export function RouterProvider() {
  return (
    <BrowserRouter>
      <NoticeProvider>
        <RoutesWithAnalytics />
      </NoticeProvider>
    </BrowserRouter>
  );
}
